/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useFormState } from "react-hook-form";
import { When } from "react-if";
import { Button, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { isNotNil } from "~/tools";
import { WorkflowFormData } from "../../types";

type Props = {
  toggleEdit: (isOpen: boolean) => void;
  onCancel: () => void;
  isEditable: boolean;
  isDirty: boolean;
};

export function EditFormControls({
  toggleEdit,
  isEditable,
  isDirty,
  onCancel,
}: Props) {
  const { errors } = useFormState<WorkflowFormData>();

  return (
    <FlexContainer justifyContent="space-between">
      <Text color={theme.color.text.text02} weight="bold" m="0">
        {getSuggestionText(isEditable, isDirty)}
      </Text>
      <When condition={isEditable}>
        <FlexContainer columnGap={theme.spacing.spacing02}>
          <When condition={isNotNil(errors.scheduler?.executionTime?.message)}>
            <Text m={0} tag="span" color="danger">
              {errors.scheduler?.executionTime?.message}
            </Text>
          </When>
          <Button
            px={theme.spacing.spacing07}
            type="submit"
            disabled={!isDirty}
            display="inline-flex"
          >
            Save
          </Button>
          <Button
            px={theme.spacing.spacing06}
            severity="medium"
            display="inline-flex"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </FlexContainer>
      </When>
      <When condition={!isEditable}>
        <Button severity="medium" onClick={() => toggleEdit(true)}>
          Edit Workflow
        </Button>
      </When>
    </FlexContainer>
  );
}

function getSuggestionText(isEditable: boolean, isDirty: boolean) {
  if (isEditable) {
    return isDirty
      ? 'There are some unsaved changes. Please click "Save" to save all changes.'
      : 'Please click "Save" to save all changes.';
  }

  return 'Please click "Edit Workflow" to start editing the workflow.';
}
